namespace TabAurous.HR {
    export interface IncomeTaxSlabDetailsRow {
        DetailsId?: number;
        IncomeTaxSlabId?: number;
        FromAmount?: number;
        ToAmount?: number;
        PerecentDeduction?: number;
        Condition?: string;
        Value?: number;
    }

    export namespace IncomeTaxSlabDetailsRow {
        export const idProperty = 'DetailsId';
        export const nameProperty = 'Condition';
        export const localTextPrefix = 'HR.IncomeTaxSlabDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            IncomeTaxSlabId = "IncomeTaxSlabId",
            FromAmount = "FromAmount",
            ToAmount = "ToAmount",
            PerecentDeduction = "PerecentDeduction",
            Condition = "Condition",
            Value = "Value"
        }
    }
}
